import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import About from "./page/about/About";
import Amenities from "./page/amenities/Amenities";
import Amenity from "./page/amenity/Amenity";
import Contact from "./page/contact/Contact";
import Copyrights from "./page/copyrights/Copyrights";
import Home from "./page/home/Home";
import Membership from "./page/membership/Membership";
import Price from "./page/price/Price";
import LoadingPage from "./page/loadingpage/LoadingPage";

function App() {
 
  return (
    <div >
      <Navbar/>
      <Home/>
      <About/>
      <Membership/>
      <Amenity/>
      <Contact/>
      <Copyrights/>
      {/* <Amenities/> */}
        {/* <Price/> */}
    </div>
  );
}

export default App;
